
<div class="collectors-club-registration">
  <div>
    <img
      height="36"
      alt="Card Ladder"
      src="@cardladder/shared/images/cardladder-pro-logo.svg"
    />
  </div>

  <div class="form-container">
    <h2>Welcome to Card Ladder PRO!</h2>

    <form @submit.prevent="submit">
      <p>Enter the email address you used to sign up for Collectors Club</p>
      <p>You'll get an email to set your password then come back here to login and you'll be good to go!</p>

      <text-input
        id="email"
        v-model.trim="email"
        type="email"
        label="Email"
        required
      />

      <btn
        loading-text="Submitting"
        type="submit"
        block
        :loading="submitting"
      >
        Submit
      </btn>

      <div class="links">
        <a class="link" @click="$router.push({ path: '/login', query: $route.query })">Back to login</a>
      </div>
    </form>
  </div>
</div>
